<ca-toolbar [user]="(user | async)?.email"
  [admin]="admin | async"
  [organisations]="(organisations | async)"
  [currentOrganisation]="(currentOrganisation | async)"
  [loggedIn]="loggedIn | async"
  (logout)="logout()"
  [sidenav]="sidenav"
  (profile)="profile()"
  [appLink]="appLink$ | async"></ca-toolbar>
<mat-sidenav-container>
  <mat-sidenav #sidenav>
    <ca-sidenav [user]="(user | async)?.email"
      [admin]="admin | async"
      [organisations]="(organisations | async)"
      [currentOrganisation]="(currentOrganisation | async)"
      [loggedIn]="loggedIn | async"
      (logout)="logout()"
      [sidenav]="sidenav"
      (close)="sidenav.close()"
      (profile)="profile()"></ca-sidenav>
  </mat-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>
<devmod-toggle bottom="2rem"></devmod-toggle>